$(document).ready(function(){
  // add popup class and image overlay from body
  $(document).on('click','.image_first',function(){
    $(this).next().addClass('display_popup_image');
    $('body').addClass('overlay_until_popup');
  });
  // remove popup class and image overlay from body
  $(document).on('click','span.cross-the-multicolumn-card',function(){
    $(this).parent().removeClass('display_popup_image');
    $('body').removeClass('overlay_until_popup');
  });

  // blog tag search functionality 

  // $('#blogSearchForm').submit(function(event){
  //    event.preventDefault(); // Prevent default form submission
  //    let year = $('#year').val(); // Get selected year
  //    //let years = year + '+';
  //    let month = $('#month').val(); // Get selected month
  //    let months = '+' + month; // Get selected month
  //    // Construct URL
  //    let categorie = $('#categories').val();
  //    let categories = '+' + categorie;
  //    var url = 'https://matildabardet.com/blogs/news/tagged/' + year + months + categories;
  //    // Redirect to the constructed URL
  //    //console.log("url",url);
  //    window.location.href = url;
  // });
  $('#blogSearchForm').submit(function(event){
    event.preventDefault(); // Prevent default form submission

    // Initialize parts array to collect URL parts
    let parts = [];
    // Collect year if selected
    let year = $('#year').val();
    if (year) {
        parts.push(year);
    }
    // Collect month if selected
    let month = $('#month').val();
    if (month) {
        parts.push(month);
    }
    // Collect category if selected
    let categories = $('#categories').val();
    if (categories) {
      parts.push(categories);
    }
    // let categorie;
    // if (categories) {
    //     categorie = 'cat-' + categories;
    //     parts.push(categorie);
    // }
    // Construct URL using the parts collected, joining with '+' if there are multiple parts
    
    if (parts.length > 0) {
      var baseUrl = 'https://matildabardet.com/blogs/news/tagged/';
      var url = baseUrl + parts.join('+');
      window.location.href = url;
    }
   
});

  // hide show the login recover part
  $(document).on('click','span#forgat_password_id',function(){
    $('.login-section').hide();
    $('.recover-form').show(); 
  });
  $(document).on('click','span#login_id',function(){
    $('.login-section').show();
    $('.recover-form').hide();
  });

  // collection fileter
  // $(document).on('click','.sidebar_button',function(){
  //   var nextElement = $(this).next();
  //   $('.sidebar_button').removeClass('rotate_span');
  //   $(this).addClass('rotate_span');
  //   $('.sidebar__display-vertical').removeClass('show_summery_div'); 
  //   if (nextElement.hasClass('show_summery_div')) {
  //       nextElement.removeClass('show_summery_div');
  //   } else {
  //       nextElement.addClass('show_summery_div');
  //   }
  // });
  // document ready is cloesed here.  

  const images = document.querySelectorAll(".bounce-up");

  // Create the observer only if screen width is <= 768px (mobile)
  function createObserver() {
    if (window.innerWidth <= 768) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            }
          });
        },
        {
          threshold: 0.1, // Trigger when 10% of the image is visible
        }
      );

      images.forEach((image) => {
        observer.observe(image);
      });
    }
  }

  // Call createObserver on page load
  createObserver();

  // Also call createObserver on window resize (to handle resizing between mobile and desktop)
  $(window).resize(function () {
    createObserver();
  });


  
  });



// $(function(){
// 	$("#filterList").keyup(function() {
// 		var valThis = $(this).val().toLowerCase();
// 		if (valThis == "") {
// 			$(".blog-articles__article.article").show();
// 		} else {
// 			$(".blog-articles__article.article").each(function() {
// 				var text = $(this).text().toLowerCase();
// 				text.indexOf(valThis) >= 0 ? $(this).show() : $(this).hide();
// 			});
// 		}
    
//     // Start - Unnecessary "matching results" code
// 		// var remainingResults = $('#testList > li[style!="display: none;"]').length;
// 		// if (valThis != '') {
// 		// 	$('small.form-text.text-muted').html('<strong>'+remainingResults+'</strong> matching results');
// 		// } else {
// 		// 	$('small.form-text.text-muted').html('');
// 		// } 
//     // End - Unnecessary "matching results" code
    
// 	});
// });
